import { render, staticRenderFns } from "./ProductSubClassCreator.vue?vue&type=template&id=50f9f384&scoped=true"
import script from "./ProductSubClassCreator.vue?vue&type=script&lang=js"
export * from "./ProductSubClassCreator.vue?vue&type=script&lang=js"
import style0 from "./ProductSubClassCreator.vue?vue&type=style&index=0&id=50f9f384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f9f384",
  null
  
)

export default component.exports